import { CustomButton } from '@atbay/component-lib'
import { styled } from '@mui/system'

export const LoadingIcon = styled('i')`
    margin-right: 5px;
`

export const ButtonContent = styled('span')`
    display: flex;
    align-items: center;
    gap: 5px;
`

export const StyledCustomButton = styled(CustomButton)<{
    buttonSize: 'small' | 'regular'
    fontWeight: 'regular' | 'medium' | 'semibold'
}>`
    height: 32px;
    font-size: ${({ buttonSize }) =>
        buttonSize === 'small' ? 'var(--font-size-s)' : 'var(--font-size-m)'};
    font-weight: ${({ fontWeight }) => `var(--font-weight-${fontWeight})`};
`
